import React, { useEffect, useState } from 'react'
import './PopUp.scss'
import { ReactComponent as CrossIcon } from "../assets/svg/body/cross.svg";
let onceFlag = true
function PopUp({modalData, setModalFlag}) {
    console.log("modalData", modalData)
    const [showMoreBtnFlag, setShowMoreBtnFlag] = useState(false)
    const [tempModalData, setTempModalData] = useState(modalData)
    useEffect(()=>{
        console.log(showMoreBtnFlag, tempModalData?.additional?.length)
        if(!onceFlag) return
        if(tempModalData?.additional?.length){
            onceFlag = false
            setShowMoreBtnFlag(true)
        }
        else setShowMoreBtnFlag(false)
        
    },[showMoreBtnFlag, tempModalData])
    return (
        <div className='PopUp'>
            <div className='popup'>
                <div className='title'>
                    {tempModalData?.title}
                    <CrossIcon onClick={() => { setModalFlag(false) }} />
                </div>
                <div className='content scroll'>
                    {
                        tempModalData?.detail?.map((item, index) => {
                            if(index % 2 === 0)
                                return (
                                    <div className='line' key={"popupLine" + index}>
                                        <div className='item'>
                                            <div className='sub-title'>{item.key}</div>
                                            <div className={item.value ? 'value' : 'value null'}>{item.value || 'null'}</div>
                                        </div>
                                        {
                                            tempModalData?.detail.length !== index + 1 ?
                                            (
                                                <div className='item'>
                                                    <div className='sub-title'>{tempModalData?.detail[index+1]?.key}</div>
                                                    <div className={tempModalData?.detail[index+1]?.value ? 'value' : 'value null'}>{tempModalData?.detail[index+1]?.value || 'null'}</div>
                                                </div>
                                            )
                                            :
                                            (<></>)
                                        }
                                    </div>
                                )
                            else return <></>
                        })
                    }
                </div>
                <div className={showMoreBtnFlag ? 'show-more' : 'hidden'} onClick={()=>{
                    setShowMoreBtnFlag(false)
                    setTempModalData({
                        ...tempModalData,
                        detail:[
                            ...tempModalData.detail,
                            ...tempModalData.additional,
                        ]
                    })
                }}>Show more...</div>
            </div>
            <div className='opacity-back' onClick={() => { setModalFlag(false) }} ></div>
        </div>
    )
}

export default PopUp
